<app-pan-button panRole [roles]="['admin']" icon="network_manage" color="warning" (click)="networkManagementModal.show()"></app-pan-button>

<app-pan-modal #networkManagementModal [topLevel]="true">
  <div header>{{ edgeDevice().serial_number }} Network Management</div>

  <div body class="max-h-[500px] overflow-y-auto">
    <app-pan-button-group class="my-2">
      <app-pan-button color="primary" [fill]="view() === 'primary' ? 'filled' : 'outline'" (click)="view.set('primary')">
        Primary (eth0)
      </app-pan-button>

      <app-pan-button color="primary" [fill]="view() === 'secondary' ? 'filled' : 'outline'" (click)="view.set('secondary')">
        Secondary (USB)
      </app-pan-button>
    </app-pan-button-group>

    @let form = currentForm();

    <div class="flex-col gap-2">
      <app-pan-form-control>
        <app-pan-floating-label>Network Configuration</app-pan-floating-label>

        <ng-select
          class="w-full mb-2"
          placeholder="Select network configuration..."
          [items]="[
            {
              label: 'DHCP (Automatic)',
              value: 'dhcp',
            },
            {
              label: 'Static IP',
              value: 'static',
            },
          ]"
          [bindLabel]="'label'"
          [bindValue]="'value'"
          [formField]="form.mode"
          (change)="resetSubFormData()"
        >
        </ng-select>
      </app-pan-form-control>
    </div>

    @if (form.mode().value() === "dhcp") {
      <app-pan-inline-alert type="info">
        The primary interface will automatically obtain an IP address, gateway, and DNS settings from your network's DHCP server.
      </app-pan-inline-alert>
    }

    @if (form.mode().value() === "static") {
      <app-pan-inline-alert type="warning">
        If the static IP configuration is incorrect or otherwise unable to establish an internet connection, change the configuration here
        to DHCP, leave the device completely disconnected from the network and powered on for at least a half hour. The device will reboot
        and revert to DHCP, at which point the IP configuration can be retried.
      </app-pan-inline-alert>

      <div class="flex-col gap-2">
        <app-pan-form-control>
          <app-pan-floating-label [required]="true">IP Address / Netmask</app-pan-floating-label>
          <input panInput type="text" placeholder="e.g., 192.168.1.100/24" [formField]="form.address" />
        </app-pan-form-control>

        @for (error of form.address().errors(); track $index) {
          <div class="text-danger">{{ error.message }}</div>
        }

        <app-pan-form-control>
          <app-pan-floating-label [required]="view() === 'primary'">Gateway</app-pan-floating-label>
          <input panInput type="text" placeholder="e.g., 192.168.1.1" [formField]="form.gateway" />
        </app-pan-form-control>

        @for (error of form.gateway().errors(); track $index) {
          <div class="text-danger">{{ error.message }}</div>
        }

        <app-pan-form-control>
          <app-pan-floating-label [required]="view() === 'primary'">DNS Server</app-pan-floating-label>
          <input panInput type="text" placeholder="e.g., 8.8.8.8" [formField]="form.dns" />
        </app-pan-form-control>

        @for (error of form.dns().errors(); track $index) {
          <div class="text-danger">{{ error.message }}</div>
        }
      </div>
    }
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Close</app-pan-button>

    <app-pan-button color="info" (click)="save()" [disabled]="!canSave()" panModalClose>Save</app-pan-button>
  </div>
</app-pan-modal>
